import React, {Component} from 'react';
import {
	FormLabeledItem,
	Input,
	ItemChooser,
	CheckBox,
	TextArea,
	SelectList,
	Button,
	FormDataObj
} from '../../../components/FormUI';
import User from '../../../api/User';

import {Grid, Segment} from 'semantic-ui-react'

import './UserForm.css';

import DatePicker from 'react-datepicker';

import moment from 'moment';
import {CountrySelectList, ClinicDoctors, ProvinceSelectList} from '../../../components/DataSelectList';
import PatientService from '../../../api/services/PatientService';
import ClinicPhysicianList from '../../../components/datalists/ClinicPhysicianList';
import {NotificationManager} from 'react-notifications';
import {AssessmentReportSideBar} from '../../Assessment/AssessmentReport';
import {SanitizeClassNames} from '../../../common';
import CalendarView from "../../CalendarView";
import InsuranceList from "../../../components/selectlists/InsuranceList";

export default class UserForm extends Component {
	form = {};
	state = {errors: {}};

	/*componentWillReceiveProps(props){
		this.form = new User(props.user || {});
	}*/

	constructor(props) {
		super(props);
		this.form = new FormDataObj(new User(this.props.user || {}));
		this.handleBODChange = this.handleBODChange.bind(this);
	}


	submit() {
		let errors = this.form.getErrorState();
		//console.log('Form Data:', this.form.data)
		if (errors != null) {
			this.setState({errors: errors});
			return;
		}
		let userService = new PatientService();
		let isNewPatient = !this.form.data.clientId;
		let msg = isNewPatient ? 'Patient Created!' : 'Patient Updated!';
		userService.save(this.form.data).then((user) => {
			this.form.data = new User(user);
			/*for(let p in user){
				this.props.user[p] = user[p];
			}*/

			this.setState({saving: false});
			NotificationManager.success(msg);
			CalendarView.Refresh();
		})
		this.setState({saving: true, errors: {}});
	}

	handleBODChange(d) {
		console.log("DOB:", d)
		this.form.data.birthDate = (d) ? moment(d).format('YYYY-M-D') : '';
		this.forceUpdate();
	}

	showAssessment = (id) => {
		this.setState({showAssessment: true, assessmentId: id});
	}

	handleCheckBox = ({value}) => {
		//console.log('Handle Check Box:', value);
		this.form.setValue('emailConsent', value);
		this.forceUpdate();
	}

	parseGender = (val) => {
		const v = (val || '').toLocaleLowerCase();
		if (v === 'male') return 'M';
		if (v === 'female') return 'F';
		return val;
	}

	/*customInput={<Input name='birthDate' value={this.form.birthDate} form={this.form} placeholder='Date of Birth' tabIndex={1} />}*/
	render() {
		console.log("UserForm:", this.form);
		this.form.data.gender = this.parseGender(this.form.data.gender);
		let user = this.form.data;
		let label = (user.clientId) ? 'Edit Client' : 'Add New Client';
		let saveLabel = (user.clientId) ? 'Update' : 'Save';
		let errors = this.state.errors;
		let assessments = [];
		let details = user;
		if (details.assessments) {
			for (let i = details.assessments.length - 1; i >= 0; i--) {
				let ass = details.assessments[i];
				let date = moment(ass.modified).format('MMMM D, YYYY');
				assessments.push(<div className='assessment-btn'
				                      onClick={() => this.showAssessment(ass.assessmentId)}>{date}</div>)
			}
		}

		//this.form = new User(this.props.user || {});
		return (
			<div className={SanitizeClassNames(this, 'user-form')}>
				<FormLabeledItem label={label} parentItem>
					<div className='form-table1 table hmax align-bottom'>
						<div>
							<div><Input placeholder='First Name' name='firstName' form={this.form} tabIndex={1}
							            error={errors['firstName']} required/></div>
							<div><Input placeholder='Last Name' name='lastName' form={this.form} tabIndex={1}
							            error={errors['lastName']} required/></div>
							<div><Input name='homePhone' form={this.form} placeholder='Home Phone' tabIndex={2}/></div>
						</div>
						<div>
							<div>
								<FormLabeledItem label='Gender'>
									<ItemChooser className='hmax' name='gender' form={this.form}>
										<div itemId='M' tabIndex={1}>Male</div>
										<div itemId='F' tabIndex={1}>Female</div>
										<div itemId='Other' tabIndex={1}>Other</div>
									</ItemChooser>

								</FormLabeledItem>
							</div>
							<div>
								<DatePicker
									tabIndex={1}
									selected={user.birthDate ? moment(user.birthDate) : null}
									showYearDropdown
									dropdownMode="select"
									scrollableYearDropdown
									onChange={this.handleBODChange}
									dateFormat='MMM DD, YYYY'
									placeholderText="Date of Birth (MM/DD/YYYY)"
									/*onBlur={(d) => this.handleBODChange(d) }*/
									onChangeRaw={
										(e) => {
											let val = e.target.value;
											this.handleBODChange(val);
										}
									}
								/>

							</div>
							<div><Input type='phone' name='cellPhone' form={this.form} placeholder='Cell Phone'
							            tabIndex={2}/></div>
						</div>
						<div>
							<div><Input name='address2' form={this.form} placeholder='Unit / Apt #' tabIndex={1}/></div>
							<div><Input name='address1' form={this.form} placeholder='Address' tabIndex={1}/></div>
							<div><Input name='workPhone' form={this.form} placeholder='Work Phone' tabIndex={2}/></div>
						</div>
						<div>
							<div><Input name='city' form={this.form} placeholder='City / Town' tabIndex={1}/></div>
							<div><Input name='postalCode' form={this.form} placeholder='Postal Code' tabIndex={1}/>
							</div>
							<div><Input type='email' name='email' form={this.form} placeholder='Email' tabIndex={2}/>
							</div>
						</div>
						<div>
							<div><ProvinceSelectList name='province' form={this.form} placeholder='Province'
							                         tabIndex={1} simpleValue={true}/></div>
							<div><CountrySelectList name='country' form={this.form} placeholder='Country' value='CA'
							                        simpleValue={true} tabIndex={1}/></div>
							<div>
								<FormLabeledItem label='Email Preferences'>
									<CheckBox radio label="None set." name='emailConsent' value='' form={this.form}
									          tabIndex={2} onChange={this.handleCheckBox}/><br/>
									<CheckBox radio label="Email marketing consent recieved." name='emailConsent'
									          value='Y' form={this.form} tabIndex={2}
									          onChange={this.handleCheckBox}/><br/>
									<CheckBox radio label="No, do not ask again." name='emailConsent' value='N'
									          form={this.form} tabIndex={2} onChange={this.handleCheckBox}/>
								</FormLabeledItem>
							</div>
						</div>
					</div>
					<div className='divider'></div>

				</FormLabeledItem>

				<div className='form-table1 table hmax align-top'>
					<div>
						<div>
							<div className='form-table2 table hmax align-bottom'>

								<div>
									<div><InsuranceList name='insurance' form={this.form} placeholder='Insurance'
									                    tabIndex={3}/></div>
									<div><Input name='insurancePlan' form={this.form} placeholder='Insurance Plan'
									            tabIndex={3}/></div>

								</div>

								<div>
									<div><Input name='insurancePolicy' form={this.form} placeholder='Insurance Policy'
									            tabIndex={3}/></div>
									<div><Input name='employer' form={this.form} placeholder='Employer' tabIndex={3}/>
									</div>
								</div>

								<div>
									<div><ClinicPhysicianList name='referringProfessional' isCreatable={true}
									                          form={this.form} placeholder='Referring Professional'
									                          tabIndex={3}/></div>
									<div><Input name='familyPhysician' form={this.form} placeholder='Family Physician'
									            tabIndex={3}/></div>

								</div>

								<div>
									<div>
										<SelectList name='howHeard' form={this.form} placeholder='How you heard of us'
										            simpleValue={true} options={[
											{label: 'Physician Referral', value: 'Physician Referral'},
											{
												label: 'Other referring professional',
												value: 'Other referring professional'
											},
											{label: 'Google', value: 'Google'},
											{label: 'Social Media', value: 'Social Media'},
											{label: 'Family / Friend', value: 'Family / Friend'},
											{label: 'Work Perks', value: 'Work Perks'},
											{label: 'Preferred Providor', value: 'Preferred Providor'},
											{label: 'Walk in / Signage', value: 'Walk in / Signage'},
											{label: 'Marketing Event', value: 'Marketing Event'},
											{label: 'Newspaper / Magazines', value: 'Newspaper / Magazines'},
											{label: 'Radio / TV', value: 'Radio / TV'},
											{label: 'Soles4Souls', value: 'Soles4Souls'},
											{label: 'Other', value: 'Other'}
										]} tabIndex={3}/>
									</div>
									<div><Input name='howHeardOther' form={this.form} placeholder='other' tabIndex={3}/>
									</div>
								</div>

								<div>
									<div>
										<FormLabeledItem label='Preferred Contact Method'>
											<ItemChooser className='hmax' name='preferredContactMethod'
											             form={this.form}>
												<div itemId='email' tabIndex={3}>Email</div>
												<div itemId='cell' tabIndex={3}>Cell #</div>
												<div itemId='home' tabIndex={3}>Home #</div>
												<div itemId='work' tabIndex={3}>Work #</div>
											</ItemChooser>
										</FormLabeledItem>
									</div>
									<div><Input name='guardian' form={this.form} placeholder='Guardian' tabIndex={3}/>
									</div>
								</div>

								<div>
									<div>
										<FormLabeledItem label='Best time to Contact'>
											<ItemChooser className='hmax' name='preferredContactTime' form={this.form}>
												<div itemId='morning' tabIndex={3}>Morning</div>
												<div itemId='afternoon' tabIndex={3}>Afternoon</div>
												<div itemId='evening' tabIndex={3}>Evening</div>
											</ItemChooser>
										</FormLabeledItem>
									</div>
									<div></div>
								</div>

								<div>
									<div></div>
									<div></div>
								</div>

							</div>
						</div>
						<div>
							<div className='form-table2 table hmax align-bottom'>
								<div>
									<div>
										<Input name='shoeSize' form={this.form} placeholder='Shoe Size' tabIndex={3}/>
									</div>
								</div>
								<div>
									<div><Input name='weightBearingHours' form={this.form}
									            placeholder='#of weight bearing hours' tabIndex={4}/></div>
								</div>
								<div>
									<div><TextArea name='personalInformation' form={this.form}
									               placeholder='Personal Information' tabIndex={4}/></div>
								</div>
								<div>
									<div>
										<FormLabeledItem label='Allergies'>
										<TextArea name='allergies' form={this.form} placeholder=''
										          tabIndex={4}/>
										</FormLabeledItem>
									</div>
								</div>
								<div>
									<div>
										<FormLabeledItem label='Assessments'>
											<div className='assessment-list'>{assessments}</div>
										</FormLabeledItem>
									</div>
								</div>
								<div>
									<div><Button caption={saveLabel} className='green' onClick={() => this.submit()}
									             isBusy={this.state.saving} tabIndex={4}/></div>
								</div>
							</div>
						</div>
					</div>
				</div>


				<AssessmentReportSideBar isOpen={this.state.showAssessment} id={this.state.assessmentId}
				                         onRequestClose={() => this.setState({showAssessment: false})}/>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/views/Clients/forms/UserForm.js